module.exports = __webpack_public_path__ + "img/deep.a13764b1.png";